module.exports = __webpack_public_path__ + "static/media/backArrowBlack.77b503a3.svg";